import styles from "./HomePage.module.css"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar/NavbarHome/Navbar";
import Footer from "../../components/Footer/Footer";
import OnboardingPopup from "../../components/Popups/Onboarding/Onboarding";
import Filter from "../../components/Filter/Filter";

import HeroCarousel from "../../components/Sections/Landing/HeroCarousel";
import GallerySection from "../../components/Sections/Landing/GallerySection";
import LandingOffersSection from "../../components/Sections/Landing/LandingOffersSection";
import PartnersSection from "../../components/Sections/Landing/PartnersSection";
import ProductSection from "./components/ProductSection/ProductSection";

import { heroSlides, filterCardConfigs, HeroAction } from "../../constants/landingSections";
import useCatalogData from "../../hooks/useCatalogData";
import { useCmsContent } from "../../hooks/useCmsContent";

import { useFilterContext } from "../../context/FilterContext";
import { useOnboardingData } from "../../hooks/useOnboardingData";
import { useProductLayout } from "../../hooks/useProductLayout";
import { useTimeModal } from "../../context/TimeModalContext";
import useEnsureCatalogData from "../../hooks/useEnsureCatalogData";
import { useCartContext } from "../../context/CartContext";
import { log } from "../../utils/logger";

/**
* Home page
* Contains hero carousel, Image gallery, Product lists, Companys partners, Activities.
* @returns TSX.Element
*/
const Home = () => {
    const { products, newProducts, items, activities, loading, loadingActivities } =
        useEnsureCatalogData({
            productSource: "products",
            reloadOnMount: true,
        });
    const {reloadCart} = useCartContext();
    // Reload cart at the start
    useEffect(()=>{
        reloadCart();
    },[])
    const { filterData, handleFilter, basicFilter, handleBasicFilter } = useFilterContext(); // Filter data
    const { productLayout, setProductLayout } = useProductLayout(); // Product layout
    const { open } = useTimeModal(); // Open time modal
    const {clearData} = useOnboardingData(); // Clear onboarding data
    const cmsContent = useCmsContent(); // CMS managed texts (undefined = use built-in fallbacks)
    const navigate = useNavigate(); // Navigate
    // Handle opening and closing the filter menu
    const [filterOpen, setFilterOpen] = useState(false)
    // Handle toggling onboarding popup
    const [onboardingOpen, setOnboardingOpen] = useState<boolean>(false);

    const handleHeroAction = (action: HeroAction) => {
        if (action === "about") {
            navigate("/about");
            return;
        }
        if (action === "onboarding") {
            setOnboardingOpen(true);
        }
    };


    useEffect(() => {
        if (!onboardingOpen) {
            const id = setTimeout(() => {
                window.scrollTo(0, 0);
            }, 100);
            return () => clearTimeout(id);
        }
    }, [onboardingOpen]);

    const catalogData = useCatalogData({
        products,
        newProducts,
        items,
        activities,
    });

    return(
        <>
        <div className={styles.Page}>
            <div className={styles.Header}>
                <Navbar/>
            </div>

                <div className={styles.Content}>
                    <Filter
                    open={filterOpen}
                    setOpen={()=>setFilterOpen(!filterOpen)}
                    />
                    <OnboardingPopup
                        display={onboardingOpen}
                        onClose={() => {
                            //log('[Onboarding] onClose called. wasOpen=', onboardingOpen);
                            setOnboardingOpen(false);
                            clearData();
                        }}
                    />

                <HeroCarousel
                    styles={styles}
                    slides={heroSlides}
                    onAction={handleHeroAction}
                    cmsSlides={cmsContent?.hero ?? undefined}
                />
                <GallerySection styles={styles} cmsImages={cmsContent?.gallery ?? undefined} />
                <LandingOffersSection
                    styles={styles}
                    filterCards={filterCardConfigs.home}
                    filterData={filterData}
                    handleFilter={handleFilter}
                    basicFilter={basicFilter}
                    handleBasicFilter={handleBasicFilter}
                    productLayout={productLayout}
                    setProductLayout={setProductLayout}
                    onOpenFilter={() => setFilterOpen(true)}
                    onOpenTimeModal={open}
                    catalogData={catalogData}
                    ProductSectionComponent={ProductSection}
                    loading={loading}
                    loadingActivities={loadingActivities}
                    showSalesButtons={false}
                    titleId="OfferSection"
                    formatPriceRange={(min, max) => `${min} - ${max}kč`}
                />
                <PartnersSection styles={styles} showTitles={true} cmsPartners={cmsContent?.partners} />
                {/*
                <div className={styles.ActivitySection}>
                    <p className={styles.ActivitySectionTitle}>
                        <Trans i18nKey="home.activities.title" components={{ 1: <span/> }} />
                    </p>
                    <div className={styles.Activities}>
                        {blogPosts.map((post,index)=>(
                            <BlogCard key={`${post.id}-${index}`} id={post.id} title={post.title} imageSrc={post.imageSrc} description={post.description} />
                        ))}
                    </div>
                </div>
                */}
            </div>
            <div className={styles.Footer}>
                <Footer/>
            </div>
        </div>
        </>
    )
};

export default Home;
